<template>
  <div class="aside-sizer">
    <div class="aside-nav">
      <div
        v-for="(item, key) in navigation"
        :key="key"
        :class="['entry', `entry-${item.icon}`, { disabled: !item.component, active: item.component === currentComponent }]"
        @click="() => updatePanel(item.component)"
      >
        <i :class="`icon-${item.icon}`"></i>
      </div>
    </div>
    <Transition name="aside-left">
      <component :is="currentComponent" :action="() => updatePanel(false)">{{ currentComponent }}</component>
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Sites from './Aside/Sites';
import TransportMode from './Aside/TransportMode';
import Collaborators from './Aside/Collaborators';
import IdealLocation from './Aside/IdealLocation';
import PublicTransport from './Aside/PublicTransport';

export default {
  components: {
    Sites,
    TransportMode,
    Collaborators,
    IdealLocation,
    PublicTransport,
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      currentComponent: 'activeAside',
      study: 'study',
      isDesktop: 'isDesktop',
      userInfo: 'userInfo',
    }),

    navigation() {
      let currentSiteOnly = false;
      if (this.study) {
        currentSiteOnly = !(this.study.sites.filter(site => site.type_id === 2).length > 0);
      }

      return [
        {
          icon: 'pin',
          component: 'Sites',
          hidden: currentSiteOnly,
        },
        {
          icon: 'bus',
          component: 'TransportMode',
        },
        {
          icon: 'people',
          component: 'Collaborators',
        },
        {
          icon: 'rank',
          component: 'IdealLocation',
          hidden: this.userInfo.role_id === 3 || !(this.study && this.study.process_heatmap),
        },
        {
          icon: 'info',
          component: 'PublicTransport',
        },
      ].filter(item => !item.hidden);
    },
  },

  methods: {
    updatePanel(currentComponent) {
      this.$store.dispatch('updateActiveAside', this.currentComponent === currentComponent ? false : currentComponent);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
$border-radius: 5px;
.aside-left-enter-active,
.aside-left-leave-active {
  transition:
    opacity 0.5s,
    transform 0.5s cubic-bezier(0.72, 0.03, 0.28, 0.97);
}
.aside-left-enter,
.aside-left-leave-to {
  opacity: 0.5;
  transform: translateX(-268px);
}
.aside-nav {
  position: fixed;
  top: 104px;
  bottom: 0;
  left: 0;
  z-index: 3;
  background-color: colors.$white-color;
  border-right: 1px solid colors.$dark-beige-color;

  .entry {
    position: relative;
    height: 54px;
    width: 54px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: colors.$white-color;
    border: 1px solid colors.$dark-beige-color;
    border-right: none;
    border-left: none;
    transition:
      background-color 0.3s ease,
      border-color 0.3s ease,
      border-width 0s,
      box-shadow 0s;
    cursor: pointer;
    box-sizing: border-box;
    box-shadow: inset 0 0 0px rgba(colors.$black-color, 0.25);

    &.disabled {
      pointer-events: none;
    }
    & + .entry {
      margin-top: -1px;
    }
    i {
      transition: color 0.3s ease;
      font-size: 1.75em;
      color: colors.$earth-color;
    }
    &.active,
    &:hover {
      background-color: colors.$navy-color;
      border-color: colors.$navy-color;
      border-width: 0px;
      box-shadow: inset 0 0 4px rgba(colors.$black-color, 0.25);
      z-index: 1;
      i {
        color: colors.$white-color;
      }
    }
  }
}
</style>
